module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_8023.d24e679f.png";